import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { SearchInformation } from '../classes/search-information';
import { Payments } from '../classes/payments';
import { Handlers } from '../classes/handlers';
import { SessionStorageService } from './session-storage.service';
import { ErrorHandlerComponent } from '../components/error-handler/error-handler.component';
import { CookieService } from 'ngx-cookie-service';


@Injectable({
  providedIn: 'root',
})
export class ClaimService {
  claimUrl;
  constructor(
    private httpClient: HttpClient, 
    private payments: Payments, 
    private handlers: Handlers, 
    private router: Router, 
    private searchInfo: SearchInformation,
    private sessionStorage: SessionStorageService,
    public errorHandler: ErrorHandlerComponent,
    private cookieService: CookieService
  ) { }


  buildParams(dol, firstName, lastName){
    let httpParams = new HttpParams()
    httpParams = httpParams.append("dol", dol)
    httpParams = httpParams.append("first_name", firstName)
    httpParams = httpParams.append("last_name", lastName)
    return httpParams
  }

  buildHeader(){
    const tokenCookie = this.cookieService.get('sf-icp-sso') ? this.cookieService.get('sf-icp-sso') : 1;
    this.sessionStorage.setSessionData('auth-token', tokenCookie)
    let httpHeader = new HttpHeaders()
    httpHeader = httpHeader.append('Authorization', String(tokenCookie))
    return httpHeader
  }

  buildRequest(claimNumber, dol, firstName, lastName){
    this.claimUrl = environment.claimEndpoint
    this.searchInfo.setDropDownValue(true)
    this.searchInfo.setClaim({number: claimNumber, dol: dol, firstName: firstName,
       lastName: lastName})
    this.claimUrl = this.claimUrl + claimNumber
    const httpParams = this.buildParams(dol, firstName, lastName)
    const httpHeader = this.buildHeader()
    return this.retrieveClaimDetails(this.claimUrl, httpParams, httpHeader)
  }

  claimSearch (claimUrl, httpParams, httpHeader){
    return this.httpClient.get(claimUrl, {params:httpParams, headers:httpHeader})
  }

  retrieveClaimDetails(claimUrl, httpParams, httpHeader){
    return this.claimSearch(claimUrl, httpParams, httpHeader).subscribe(data => {
      const response = data
      this.payments.setPayments(response['payload']['payments'])
      this.handlers.setHandlers(response['payload']['claim_handlers'])
      this.router.navigateByUrl('/claim-found')
    }, error => {
      this.errorHandler.handleError(error.status)
    })
  }

}
